import React from 'react'
import {useNavigate} from "react-router-dom";
import styles from "./UserNav.module.css";

const UserNav = () => {
    const navigate = useNavigate();
  return (
    <>
    <div className={styles.mainUserNav}>
        <div onClick={()=>{navigate('/')}}><img src="/images/GS.png" alt="logo" width="50px" style={{paddingLeft:"10px"}}/></div>
        <div className={styles.nav}>
          <button onClick={()=>{navigate('/users')}}>User</button>
          <button onClick={()=>{navigate('/history')}}>History</button>
          <button onClick={()=>{navigate('/cart')}}>Cart</button>
          <button onClick={()=>{localStorage.removeItem('token');navigate('/login')}}>Logout</button>
        </div>
      </div>
      </>
  )
}

export default UserNav